import { JustificativaModal } from '@components/Modal/JustificativaModal';
import { IForm } from '@hooks/useForm';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { IModalWindow } from '@hooks/useModalWindow';
import { IJustificativaRequest } from '@hooks/useRequest';
import IFatura from '@model/Fatura';
import { useFaturaService } from '@services/FaturaService';
import { AxiosResponse } from 'axios';
import React from 'react';

export type FaturaReabrirModalProps = {
    modal: IModalWindow
    fatura: IFatura
    onFaturaReaberta: (response: AxiosResponse<IFatura>) => void
}

export function FaturaReabrirModal ({ modal, fatura, onFaturaReaberta }: FaturaReabrirModalProps) {
    const loading = useLoading();
    const message = useMessage();

    const faturaService = useFaturaService();

    const handleConfirm = React.useCallback((values: IJustificativaRequest, form: IForm<IJustificativaRequest>)  => {
        if (!loading.isLoading) {
            loading.start();
            faturaService.reabrir(fatura.faturaId, values)
                .then(response => {
                    message.success("Fatura reaberta com sucesso");
                    modal.close();
                    onFaturaReaberta(response);
                })
                .catch(e => {
                    message.handleResponse(e)
                        .badRequest(form.setErrorsFromServer)
                        .showException();
                })
                .finally(loading.stop);
        }
    }, [fatura.faturaId, faturaService, loading, message, modal, onFaturaReaberta]);

    return (
        <JustificativaModal 
            confirmText="Reabrir Fatura"
            disabled={loading.isLoading}
            modal={modal}
            onConfirm={handleConfirm}
            title={`Reabertura da Fatura ${fatura.faturaId}`}
        />
    )
}